import React from "react";
import { AreaChart, Area, XAxis, YAxis, ResponsiveContainer, Tooltip, ReferenceLine } from "recharts";

const seed = (len, base, amp, phase = 0) => {
  return Array.from({ length: len }, (_, i) => ({
    t: i,
    v: Math.max(
      0,
      Math.min(100, base + Math.sin((i + phase) * 0.45) * amp + Math.sin(i * 0.18) * (amp * 0.4))
    ),
  }));
};

export const GpuTelemetry = ({ mode = "inboost", data, color, label = "GPU UTIL %", testid }) => {
  const fallback = mode === "inboost" ? seed(48, 84, 4, 1) : seed(48, 36, 14, 3);
  const series = data || fallback;
  const c = color || (mode === "inboost" ? "#0099C9" : "#E11D48");

  return (
    <div className="w-full h-full" data-testid={testid}>
      <div className="flex items-center justify-between text-[10px] mono uppercase tracking-widest mb-2">
        <span style={{ color: c }}>{label}</span>
        <span className="text-muted">DCGM</span>
      </div>
      <ResponsiveContainer width="100%" height={160}>
        <AreaChart data={series} margin={{ top: 4, left: -28, right: 4, bottom: 0 }}>
          <defs>
            <linearGradient id={`grad-${mode}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={c} stopOpacity={0.55} />
              <stop offset="100%" stopColor={c} stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <XAxis dataKey="t" hide />
          <YAxis domain={[0, 100]} tick={{ fill: "#5C6A82", fontSize: 9, fontFamily: "JetBrains Mono" }} axisLine={false} tickLine={false} />
          <Tooltip
            contentStyle={{
              background: "rgba(255,255,255,0.95)",
              border: "1px solid rgba(0,80,230,0.2)",
              borderRadius: 8,
              boxShadow: "0 8px 24px rgba(10,15,30,0.08)",
              fontFamily: "JetBrains Mono",
              fontSize: 11,
              color: "#0A0F1E",
            }}
            labelStyle={{ color: "#5C6A82" }}
            itemStyle={{ color: c }}
            formatter={(v) => [`${Number(v).toFixed(1)}%`, "Util"]}
          />
          <ReferenceLine y={85} stroke="#00B85A" strokeDasharray="3 3" opacity={0.5} />
          <Area type="monotone" dataKey="v" stroke={c} strokeWidth={1.8} fill={`url(#grad-${mode})`} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GpuTelemetry;
